import React from "react";
import {
  Backdrop,
  CircularProgress,
  Typography,
  Box,
  Button,
  Stack,
} from "@mui/material";

const DownloadProgressOverlay = ({
  open,
  current,
  total,
  filename,
  shipmentNumber,
  loaderName,
  vehicleNumber,
  onCancel,
}) => {
  return (
    <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={open}>
      <Box textAlign="center">
        <CircularProgress color="inherit" />
        <Typography mt={2} variant="h6">
          Mengunduh foto {current} dari {total}
        </Typography>

        {filename && (
          <Typography mt={1} variant="body2">
            {filename}
          </Typography>
        )}

        <Box mt={3}>
          {shipmentNumber && (
            <Typography variant="subtitle1">
              📦 No Shipment: {shipmentNumber}
            </Typography>
          )}
          {loaderName && (
            <Typography variant="subtitle1">🧑‍🔧 Loader: {loaderName}</Typography>
          )}
          {vehicleNumber && (
            <Typography variant="subtitle1">
              🚚 No Mobil: {vehicleNumber}
            </Typography>
          )}
        </Box>

        <Stack direction="row" justifyContent="center" spacing={2} mt={3}>
          <Button variant="contained" color="error" onClick={onCancel}>
            Batalkan Download
          </Button>
        </Stack>
      </Box>
    </Backdrop>
  );
};

export default DownloadProgressOverlay;
